export default "__VITE_ASSET__6f7dac43__"